import { render, staticRenderFns } from "./InvoicePib.vue?vue&type=template&id=4aa47dd9"
import script from "./InvoicePib.vue?vue&type=script&lang=js"
export * from "./InvoicePib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports